export default __webpack_public_path__ + "static/media/page9Image1_en.df5c2b78.jpg";